export const getComponent = (list, cName) =>
  list.find(({ name }) => name === cName).component;
